var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{attrs:{"height":"432px"}},_vm._l((_vm.slidePics),function(item,index){return _c('el-carousel-item',{key:index,nativeOn:{"click":function($event){return _vm.toNewsDetails(index)}}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":item.image,"alt":""}})])}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler?{"id":"data-v-6b9ad1d8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Slide.vue
// module id = null
// module chunks = 